import { render } from "./ImageUploadForm.vue?vue&type=template&id=39bb5014&scoped=true&ts=true"
import script from "./ImageUploadForm.vue?vue&type=script&lang=ts"
export * from "./ImageUploadForm.vue?vue&type=script&lang=ts"

import "./ImageUploadForm.vue?vue&type=style&index=0&id=39bb5014&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bb5014"]])

export default __exports__